import { useSearchParams } from 'next/navigation';
import classNames from 'classnames';
import styles from './multilevel-filters.module.scss';
import {
  FILTER_CATEGORY_KEY,
  FilterCategory,
} from './multilevel-filters-types';

type FilterCategoryButtonProps = {
  filterCategories: FilterCategory[];
  handleFilterCategory: (filterCategory: FilterCategory) => void;
};

export const isFilterActive = (
  value: string | null = '',
  activeFilter: string | null = ''
) => value === activeFilter;

const FilterCategoryButton = ({
  filterCategories,
  handleFilterCategory,
}: FilterCategoryButtonProps) => {
  const searchParams = useSearchParams();
  const activeFilterCategory = searchParams.get(FILTER_CATEGORY_KEY);

  if (!filterCategories?.length) return null;

  return (
    <div className={styles.filterCategoryButtonContainer}>
      <ul className={styles.filterCategoryList}>
        {filterCategories.map((filterCategory) => (
          <li
            key={filterCategory?.$unique_key}
            className={styles.filterListItem}
          >
            <button
              className={classNames([
                styles.filterCategoryButton,
                {
                  [styles.activeCategory]: isFilterActive(
                    filterCategory.categoryValue,
                    activeFilterCategory
                  ),
                },
              ])}
              type="button"
              onClick={() => handleFilterCategory(filterCategory)}
            >
              {filterCategory.categoryName}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilterCategoryButton;
